import { http } from "@/utils/http";
import { baseApi, baseUrlApi, type IResponseType } from "./utils";

export type UserResult = {
  error: boolean;
  data: {
    /** 头像 */
    avatar: string;
    /** 用户名 */
    username: string;
    /** 当前登录用户的角色 */
    roles: Array<string>;
    /** 按钮级别权限 */
    permissions: Array<string>;
    /** `token` */
    token: string;
    /** 用于调用刷新`token`的接口时所需的`token` */
    refreshToken: string;
    /** `token`的过期时间（格式'xxxx/xx/xx xx:xx:xx'） */
    expires: Date;
  };
};

export type RefreshTokenResult = {
  success: boolean;
  data: {
    /** `token` */
    token: string;
    /** 用于调用刷新`token`的接口时所需的`token` */
    refreshToken: string;
    /** `token`的过期时间（格式'xxxx/xx/xx xx:xx:xx'） */
    expires: Date;
  };
};

export type TSelectUser = {
  code: Number;
  error: boolean;
  data: any;
};

/** 登录 */
export const getLogin = (data?: object) => {
  return http.request<UserResult>(
    "post",
    baseApi("platform/user/login/login"),
    { data }
  );
};

/** 短信登录 */
export const smsLoginApi = (data?: object) => {
  return http.request<UserResult>(
    "post",
    baseApi("platform/user/login/smsLogin"),
    { data }
  );
};

/** 刷新`token` */
export const refreshTokenApi = (data?: object) => {
  return http.request<RefreshTokenResult>("post", "/refresh-token", { data });
};

/** 测试 */
export const testApi = (data?: string) => {
  return http.request("post", baseUrlApi("test"), { data });
};

/** 查询用户列表 */
export const selectUserApi = () => {
  return http.request<TSelectUser>(
    "get",
    baseApi("workflow/identity/selectUser")
  );
};

/** 查询用户消息 */
export const getNoticeMsgApi = params => {
  return http.request<TSelectUser>("post", baseApi("noticeMsg/query"), {
    params
  });
};

/** 已读 */
export const setNoticeMsgApi = params => {
  return http.request<TSelectUser>("post", baseApi("noticeMsg/read"), {
    params
  });
};

/** 获取验证码 */
export const loginSmsApi = (params?: object) => {
  return http.request<IResponseType>(
    "get",
    baseApi("platform/user/login/loginSms"),
    { params }
  );
};
